// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function ugandaOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'ug',
    phone_number: userInputValues['ugandaPhoneNumber'],
  };
}
